import useAuth from "src/hooks/useAuth";
import useSWR from "swr";
import { fetcher } from "src/api/API";

const useGetAllSubAccountDropdownList = selectedGroups => {
    const { getAccessToken, loggedInUser } = useAuth();
    const isAdmin = loggedInUser.adminRole.adminRead;
    const requestUrl = isAdmin ? `sub_accounts` : `granted_subaccounts`;
    const { data, error, mutate } = useSWR([requestUrl, getAccessToken], fetcher, {
        revalidateOnFocus: false,
    });

    let dropdownList = [];
    if (isAdmin && data && data.length) {
        const subAccountsWithGroupNames = data
            .map(g => {
                return g.subAccountNames.map(name => {
                    return { groupName: g.groupName, name };
                });
            })
            .flat();

        dropdownList = subAccountsWithGroupNames.map(subAccountInfo => {
            return {
                text: subAccountInfo.name + ", " + subAccountInfo.groupName,
                value: subAccountInfo.name + ", " + subAccountInfo.groupName,
                groupName: subAccountInfo.groupName,
            };
        });
        if (
            !sessionStorage.getItem("selectedSubAccount") &&
            dropdownList &&
            dropdownList.length > 0
        ) {
            sessionStorage.setItem("selectedSubAccount", dropdownList[0].value);
        }
    } else if (!isAdmin && data && data.length && selectedGroups.length) {
        const selectedGroupNames = selectedGroups.map(g => g.name);
        const filteredGroups = data.filter(g => selectedGroupNames.includes(g.groupName));
        const subAccountsWithRoles = filteredGroups
            .map(g => {
                return g.subAccountNamesAndRoles.map(account => {
                    return {
                        name: account.name,
                        role: account.role,
                        groupName: g.groupName,
                    };
                });
            })
            .flat();

        dropdownList = subAccountsWithRoles.map(subAccountInfo => {
            return {
                text:
                    subAccountInfo.name +
                    ", " +
                    subAccountInfo.role?.charAt(0).toUpperCase() +
                    subAccountInfo.role?.slice(1),
                value:
                    subAccountInfo.name +
                    ", " +
                    subAccountInfo.role?.charAt(0).toUpperCase() +
                    subAccountInfo.role?.slice(1),
                groupName: subAccountInfo.groupName,
            };
        });
    }

    let errorMsg = "";
    if (error && error.response?.data) {
        errorMsg =
            error.response.data?.message === "No message available"
                ? `Error: ${error.response.data.error}`
                : `Error: ${error.response.data.message}`;
    } else if (error && !error.response?.data) {
        errorMsg = "Error";
    }

    return {
        data: !error ? dropdownList : [],
        isLoading: !error && !data,
        isError: errorMsg,
        mutate,
    };
};

export default useGetAllSubAccountDropdownList;
